<order-details [order]="changeSet.order" [changeSet]="adjustChangeSet(changeSet)" [detailsVisible]="true" [editable]="false" [collapsable]="true" [withProductDetails]="!isLead"
			   [useOriginalTranslations]="!latestOrderChanges"></order-details>

@if (changeSet.order.additionalQuestionsSubmitted) {
	<additional-questions-details [order]="changeSet.order" [changeSet]="changeSet" [detailsVisible]="true" [collapsable]="true" [editable]="false"
								  [useOriginalTranslations]="!latestOrderChanges"></additional-questions-details>
}

@if (checkIfDocumentsUploaded()) {
	<div>
		<transfer-documents-info [order]="changeSet.order" [blockInputs]="true" [detailsVisible]="true" [changeSet]="changeSet"></transfer-documents-info>
	</div>
}

@if (billingInfoVisible && billingExists) {
	<billing-information [order]="changeSet.order" [changeSet]="changeSet" [editable]="false" [detailsVisible]="true" [multipleAppearance]="true"></billing-information>
}
@if (translationsHelper.translationCommentExists(!latestOrderChanges)) {
	<translation-field [previewMode]="true" [isComment]="true" [translatedText]="translationsHelper.getComment(!latestOrderChanges)"></translation-field>
}
